import {useState} from 'react'
import {PageHeader, TabsComponent, CardComponent} from '@/components/molecules'
import {useSearchParams} from 'react-router-dom'
import {UploadTemplateWithModal} from '@/components/organisms'

/**
 * Fulfillment component that manages warehouse and inventory management interface.
 * Includes card-based navigation and tabbed content display.
 * 
 * @returns {JSX.Element} The rendered fulfillment page component.
 */
export const Fullfillment = () => {
  const [params] = useSearchParams()
  const tab = params.get('tab') ? parseInt(params.get('tab')) : 1
  const [openUpload, setOpenUpload] = useState(false)

  /**
   * Configuration for action cards displayed at the top of the page
   * @type {Array<{centralIcon: string, ctaPrimary: {text: string, onClick: Function}, title: string}>}
   */
  const cardList = [
    {
      centralIcon: 'local_police',
      ctaPrimary: {
        text: 'Add Template',
        onClick: () => console.log('add template'),
      },
      title: 'Warehouses',
    },
    {
        centralIcon: 'local_police',
        ctaPrimary: {
          text: 'Add Template',
          onClick: () => setOpenUpload(true),
        },
        title: 'Inventory',
      },
  ]

  /**
   * Configuration for tab panels and their content
   * @type {Array<{id: string, tabLabel: string, title: string, tabComponent: JSX.Element}>}
   */
  const tabList = [
    {
      id: 'Warehouses',
      tabLabel: 'Warehouses',
      title: 'Warehouses',
      tabComponent: <div>Warehouses</div>,
    },
    {
      id: 'Inventory',
      tabLabel: 'Inventory',
      title: 'Inventory',
      tabComponent: <div>Inventory</div>,
    },
  ]

  return (
    <div className="salesTargetsContainer flex flex-col">
      <PageHeader title="Fullfillment" />
      <div className="targetCardComponent mb-5">
        <CardComponent cardList={cardList} />
      </div>
      <TabsComponent tabList={tabList} defaultTabIndex={tab} />
      <UploadTemplateWithModal openUpload={openUpload} setOpenUpload={setOpenUpload} />
    </div>
  )
}
